module.exports = __webpack_public_path__ + "fonts/Inter-Light.5d3776e.woff";